import {isNil, isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {FinancingMoney} from '../types/FinancingMoney';
import {areMoneyValuesEqual} from './areMoneyValuesEqual';

/**
 * Tells whether a money field carries an override. An absent template value cannot be matched, so
 * any amount the body holds counts as an override.
 */
export function isMoneyOverride(value: FinancingMoney, templateValue: FinancingMoney | Nullish) {
  return isNotNil(value) && (isNil(templateValue) || !areMoneyValuesEqual(value, templateValue));
}
